
<div class="col-6">
    <select class="form-select" [(ngModel)]="SelectedOption" (ngModelChange)="updateFilterSettings()" [compareWith]="compareFilterOptions">
        <option *ngFor="let option of Options" [ngValue]="option">
            {{ option.Name }}
        </option>
    </select>
</div>
<div class="col-6">
    <div class="row">
        <div class="col">
            <input #filterInput class="form-control" [(ngModel)]="Value" (ngModelChange)="updateFilterSettings()" (keyup.enter)="FilterInputComplete.emit()" />
        </div>
    </div>
</div>